// TODO: ir añadiendo caracteristicas

import { configureStore } from '@reduxjs/toolkit';
import { agencyServiceApi } from 'redux/services/agencyService';
import { alertsServiceApi } from 'redux/services/alertsService';
import { eventsServiceApi } from 'redux/services/eventsService';
import { webServiceApi } from './services/webService';
import { categoryServiceApi } from 'redux/services/categoryService';
import { directionsServiceApi } from 'redux/services/directionsService';
import { favoritesServiceApi } from 'redux/services/favoritesService';
import { iconsServiceApi } from 'redux/services/iconsServices';
import { linesServiceApi } from 'redux/services/linesService';
import { plannerServiceApi } from 'redux/services/plannerService';
import { poisServiceApi } from 'redux/services/poisService';
import { imageServiceApi } from 'redux/services/imageService';
import { newsServiceApi } from 'redux/services/newsService';
import { shapesServiceApi } from 'redux/services/shapesService';
import { stopsServiceApi } from 'redux/services/stopsService';
import { transportModeServiceApi } from 'redux/services/transportmodeService';
import { userServiceApi } from 'redux/services/userService';
import agencysSlices from 'redux/slices/agencysSlice';
import categorySlices from 'redux/slices/categorySlice';
import { contextualSlice } from 'redux/slices/contextualSlice';
import favoritesSlice from 'redux/slices/favoritesSlice';
import iconsSlices from 'redux/slices/iconsSlice';
import linesSlices from 'redux/slices/linesSlice';
import mapSlice from 'redux/slices/mapSlice';
import { navigationSlice } from 'redux/slices/navigationSlice';
import permissionSlice from './slices/permissionSlice';
import { plannerSegmentsSlice } from 'redux/slices/plannerSegmentsSlice';
import { plannerSlice } from 'redux/slices/plannerSlice';
import { plannerTimerSlice } from 'redux/slices/plannerTimerSlice';
import poisSlices from 'redux/slices/poisSlices';
import subMenuIndexSlices from 'redux/slices/subMenuSlices';
import { searchSlice } from 'redux/slices/searchSlice';
import stopsSlices from 'redux/slices/stopsSlice';
import { nominatimSlice } from './slices/nominatimSlice';
import alertsSlice from 'redux/slices/alertsSlice';
import topSearchBarSlice from 'redux/slices/topSearchBarSlice';
import transportmodeSlices from 'redux/slices/transportmodeSlice';
import userSlice from 'redux/slices/userSlice';
import filtersSlice from 'redux/slices/filtersSlice';
import markersSlice from 'redux/slices/markersSlice';
import newsSlice from 'redux/slices/newsSlice';
import recentSearchsSlice from './slices/recentSearchsSlice';
import accessSlice from 'redux/slices/accessSlice';
import eventsSlice from 'redux/slices/eventsSlice';
import webSlice from 'redux/slices/webSlice';
import imageSlice from 'redux/slices/imageSlice';
import routesSlice from './slices/routesSlice';
import { routesServiceApi } from './services/routesService';
import { staticPagesService } from './services/staticPagesService';
import { noticesServiceApi } from './services/noticesService';
import { surveyServiceApi } from './services/surveyService';
import { surveySlice } from './slices/surveySlice';

export const reducer = {
  user: userSlice,
  permission: permissionSlice,
  map: mapSlice,
  events: eventsSlice,
  web: webSlice,
  agencys: agencysSlices,
  category: categorySlices,
  favorites: favoritesSlice,
  access: accessSlice,
  images: imageSlice,
  icons: iconsSlices,
  stops: stopsSlices,
  alerts: alertsSlice,
  routes: routesSlice,
  pois: poisSlices,
  subMenu: subMenuIndexSlices,
  lines: linesSlices,
  transportmode: transportmodeSlices,
  filters: filtersSlice,
  markers: markersSlice,
  news: newsSlice,
  recentSearchs: recentSearchsSlice,
  topSearchBar: topSearchBarSlice,
  [plannerSlice.name]: plannerSlice.reducer,
  [contextualSlice.name]: contextualSlice.reducer,
  [nominatimSlice.name]: nominatimSlice.reducer,
  [plannerTimerSlice.name]: plannerTimerSlice.reducer,
  [plannerSegmentsSlice.name]: plannerSegmentsSlice.reducer,
  [navigationSlice.name]: navigationSlice.reducer,
  [searchSlice.name]: searchSlice.reducer,
  [surveySlice.name]: surveySlice.reducer,
  [shapesServiceApi.reducerPath]: shapesServiceApi.reducer,
  [iconsServiceApi.reducerPath]: iconsServiceApi.reducer,
  [imageServiceApi.reducerPath]: imageServiceApi.reducer,
  [agencyServiceApi.reducerPath]: agencyServiceApi.reducer,
  [plannerServiceApi.reducerPath]: plannerServiceApi.reducer,
  [categoryServiceApi.reducerPath]: categoryServiceApi.reducer,
  [favoritesServiceApi.reducerPath]: favoritesServiceApi.reducer,
  [newsServiceApi.reducerPath]: newsServiceApi.reducer,
  [linesServiceApi.reducerPath]: linesServiceApi.reducer,
  [poisServiceApi.reducerPath]: poisServiceApi.reducer,
  [stopsServiceApi.reducerPath]: stopsServiceApi.reducer,
  [alertsServiceApi.reducerPath]: alertsServiceApi.reducer,
  [eventsServiceApi.reducerPath]: eventsServiceApi.reducer,
  [webServiceApi.reducerPath]: webServiceApi.reducer,
  [directionsServiceApi.reducerPath]: directionsServiceApi.reducer,
  [transportModeServiceApi.reducerPath]: transportModeServiceApi.reducer,
  [userServiceApi.reducerPath]: userServiceApi.reducer,
  [staticPagesService.reducerPath]: staticPagesService.reducer,
  [routesServiceApi.reducerPath]: routesServiceApi.reducer,
  [noticesServiceApi.reducerPath]: noticesServiceApi.reducer,
  [surveyServiceApi.reducerPath]: surveyServiceApi.reducer,
};

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
      logger: false,
      /* {
        ignoredPaths: ['lines.linesStore', 'stops.stopsStore','alerts.alertsStore', 'routes.routesStore','pois.poisStore', 'category.catecoryStore', 'favorites.favoritesStore', 'transportmode.transportModeStore', 'agencys.dataOrigin', 'agencys.agencysStore', 'icons.iconsStore','images.imagesStore', 'map', 'poisLoc'],
        warnAfter: 80,
      }, */
    }).concat(
      agencyServiceApi.middleware,
      categoryServiceApi.middleware,
      favoritesServiceApi.middleware,
      imageServiceApi.middleware,
      newsServiceApi.middleware,
      linesServiceApi.middleware,
      shapesServiceApi.middleware,
      poisServiceApi.middleware,
      plannerServiceApi.middleware,
      stopsServiceApi.middleware,
      alertsServiceApi.middleware,
      eventsServiceApi.middleware,
      webServiceApi.middleware,
      directionsServiceApi.middleware,
      transportModeServiceApi.middleware,
      userServiceApi.middleware,
      iconsServiceApi.middleware,
      staticPagesService.middleware,
      routesServiceApi.middleware,
      noticesServiceApi.middleware,
      surveyServiceApi.middleware,
    );
  },
});

export type RootState = ReturnType<typeof store.getState>;
